// extracted by mini-css-extract-plugin
export default {"shop_item":"ShopItem_shop_item__+0Dqo"};